import { get } from '../../utils/api'
import { AxiosResponse } from 'axios'

export const fetchUser = (id: string): Promise<AxiosResponse> =>
  get(`/users/${id}`, {
    include: [
      'profile',
      'userAchievements',
      'userAchievements.achievement',
      'achievements',
    ].join(','),
    append: ['raw_external_profile', 'agents', 'referrals'].join(','),
  })

export const fetchUserStat = (id: string): Promise<AxiosResponse> =>
  get(`/users/${id}/stat`, {
    include: [
      'courses.userCourse',
      'courses.modules.userModule',
      'courses.modules.moduleLessons.lesson.userLesson',
    ].join(','),
  })
